import { findNadkomplet } from "actions/findNadkomplet";
import { AppContext } from "context/AppContext";
import { TechnologyContext } from "context/TechnologyContext";
import { useContext } from "react";

export const useArkuszeAuto = () => {
    const { elementyTech, produktyTech, arkusze, setArkusze, legi, setLegi, legiFragmenty, setLegiFragmenty, rodzajLegi, iloscLeg, iloscOkladek } = useContext(TechnologyContext);
    const { nadkomplety } = useContext(AppContext);

    let oprawa_klejona = [50, 51, 52, 61, 62, 63, 64, 65, 66];
    let oprawa_zeszyt = [54, 55, 56, 57, 58, 59];
    
    let oprawa = parseInt(produktyTech[0]?.oprawa, 10);

    const wygenerujArkuszeDrukowe = (elementTech, kolejnoscLeg, istniejaceArkusze = [], istniejaceLegi = [], istniejaceFragmenty = [], nadkomplety) => {
        let nextArkuszId = istniejaceArkusze.length > 0 ? Math.max(...istniejaceArkusze.map(a => a.id)) + 1 : 1;
        let nextLegaId = istniejaceLegi.length > 0 ? Math.max(...istniejaceLegi.map(l => l.id)) + 1 : 1;
        let nextFragmentId = istniejaceFragmenty.length > 0 ? Math.max(...istniejaceFragmenty.map(f => f.id)) + 1 : 1;

        let noweArkusze = [];
        let noweLegi = [];
        let noweFragmenty = [];

        const glownaLegaRozmiar = elementTech.lega; // np. 16
        const maxLegNaArkusz = elementTech.ilosc_leg; // np. dowolna liczba (1, 2, 3, 4 itd.)
        const bazowyNaklad = elementTech.naklad; // np. 1000

        // 1. KROK: Przygotowanie surowych danych leg z kolejnoscLeg
        let wygenerowaneLegiPomocnicze = kolejnoscLeg.map((rozmiarLegi, index) => {
            return {
                indeks: index + 1,
                rodzaj_legi: rozmiarLegi,
                ilosc_stron: rozmiarLegi,
                nr_legi: String(index + 1)
            };
        });

        let i = 0;
        let nrArkuszaCounter = 1;

        while (i < wygenerowaneLegiPomocnicze.length) {
            let aktualnaLegaInfo = wygenerowaneLegiPomocnicze[i];
            let arkuszLegiGrupa = [];

            // Reguła grupowania:
            // - Mniejsze legi niż główna zawsze idą jako pojedyncza pozycja na arkusz drukowy
            // - Główne legi pakujemy w paczki do osiągnięcia maxLegNaArkusz
            if (aktualnaLegaInfo.rodzaj_legi < glownaLegaRozmiar) {
                arkuszLegiGrupa.push(aktualnaLegaInfo);
                i++;
            } else {
                // Pakujemy główne legi do limitu maxLegNaArkusz
                while (
                    i < wygenerowaneLegiPomocnicze.length && 
                    arkuszLegiGrupa.length < maxLegNaArkusz && 
                    wygenerowaneLegiPomocnicze[i].rodzaj_legi >= glownaLegaRozmiar
                ) {
                    arkuszLegiGrupa.push(wygenerowaneLegiPomocnicze[i]);
                    i++;
                }
            }

            let iloscLegNaTymArkuszu = arkuszLegiGrupa.length;
            let sumaStronNaArkuszu = arkuszLegiGrupa.reduce((acc, l) => acc + l.ilosc_stron, 0);

            // Uniwersalne przeliczenie nakładu arkusza względem maksymalnej pojemności
            let maxPojemnoscArkusza = glownaLegaRozmiar * maxLegNaArkusz;
            let mnoznikNakladuArkusza = maxPojemnoscArkusza / sumaStronNaArkuszu;
            let nakladArkusza = Math.ceil(bazowyNaklad / mnoznikNakladuArkusza);

            // 2. KROK: Tworzymy obiekt Arkusza
            let nowyArkusz = {
                global_id: null,
                indeks: nrArkuszaCounter,
                technologia_id: elementTech.technologia_id,
                element_id: elementTech.id,
                typ_elementu: parseInt(elementTech.typ),
                rodzaj_arkusza: sumaStronNaArkuszu,
                ilosc_stron: sumaStronNaArkuszu,
                ilosc_leg: iloscLegNaTymArkuszu,
                naklad: nakladArkusza,
                nadkomplet: findNadkomplet(nadkomplety, nakladArkusza),
                uwagi: "",
                id: nextArkuszId++,
                nr_arkusza: String(nrArkuszaCounter),
                papier_id: elementTech.papier_id,
                papier_postac_id: elementTech.papier_postac_id,
                arkusz_szerokosc: elementTech.arkusz_szerokosc,
                arkusz_wysokosc: elementTech.arkusz_wysokosc,
                korekta_zamowienia_alert: null,
                zamowienie_id: elementTech.zamowienie_id,
                druk_zrealizowano: null,
                zmodyfikowano: new Date().toISOString(),
                grupa_id: null,
                grupa_indeks: null
            };

            noweArkusze.push(nowyArkusz);

            // 3. KROK: Tworzymy Legi i Fragmenty
            arkuszLegiGrupa.forEach(legaInfo => {
                let nowaLega = {
                    global_id: null,
                    id: nextLegaId++,
                    indeks: parseInt(legaInfo.nr_legi),
                    technologia_id: elementTech.technologia_id,
                    element_id: elementTech.id,
                    typ_elementu: parseInt(elementTech.typ),
                    rodzaj_legi: legaInfo.rodzaj_legi,
                    ilosc_stron: legaInfo.ilosc_stron,
                    naklad: bazowyNaklad,
                    uwagi: "",
                    arkusz_id: nowyArkusz.id,
                    nr_legi: legaInfo.nr_legi,
                    korekta_zamowienia_alert: null,
                    zamowienie_id: elementTech.zamowienie_id
                };
                noweLegi.push(nowaLega);

                let nowyFragment = {
                    global_id: null,
                    id: nextFragmentId++,
                    indeks: 1,
                    technologia_id: elementTech.technologia_id,
                    element_id: elementTech.id,
                    fragment_id: nextFragmentId,
                    arkusz_id: nowyArkusz.id,
                    lega_id: nowaLega.id,
                    nr_legi: legaInfo.nr_legi,
                    oprawa_id: 1,
                    typ: parseInt(elementTech.typ),
                    wersja: "",
                    naklad: bazowyNaklad,
                    korekta_zamowienia_alert: null,
                    zamowienie_id: elementTech.zamowienie_id
                };
                noweFragmenty.push(nowyFragment);
            });

            nrArkuszaCounter++;
        }
        
        return { noweArkusze, noweLegi, noweFragmenty };
    };

    const autoArk = () => {
        let akumulowaneArkusze = [...arkusze];
        let akumulowaneLegi = [...legi];
        let akumulowaneFragmenty = [...legiFragmenty];

        const przetworzElementy = (filtrowaneElementy) => {
            filtrowaneElementy.forEach((item) => {
                const wynik = wygenerujArkuszeDrukowe(
                    item, 
                    item.kolejnoscLeg, 
                    akumulowaneArkusze, 
                    akumulowaneLegi, 
                    akumulowaneFragmenty, 
                    nadkomplety
                );

                akumulowaneArkusze.push(...wynik.noweArkusze);
                akumulowaneLegi.push(...wynik.noweLegi);
                akumulowaneFragmenty.push(...wynik.noweFragmenty);
            });
        };

        // Środki (zależnie od oprawy)
        if (oprawa_klejona.includes(oprawa)) {
            przetworzElementy(elementyTech.filter(x => x.typ == '2'));
        } else if (oprawa_zeszyt.includes(oprawa)) {
            przetworzElementy(elementyTech.filter(x => x.typ == '2'));
        }

        // Okładki / typ '1'
        przetworzElementy(elementyTech.filter(x => x.typ == '1'));
        przetworzElementy(elementyTech.filter(x => x.typ >'2'));

        // Jedno bezpieczne uaktualnienie stanów na samym końcu
        setArkusze(akumulowaneArkusze);
        setLegi(akumulowaneLegi);
        setLegiFragmenty(akumulowaneFragmenty);
    };

    return { autoArk };
}